import { Box } from "@mui/material";
import { useRef, useContext, useEffect } from "react";
import { MapViewContext } from "../contexts/MapViewContext";

const MapRoot = () => {
	const mapDiv = useRef(null);
	const mapView = useContext(MapViewContext);

	useEffect(() => {
		if (!mapDiv.current || !mapView?.map) return;
		mapView.container = mapDiv.current;
	}, [mapView]);

	return (
		<Box
			component="div"
			ref={mapDiv}
			margin="0"
			padding="0"
			flex={1}
			display="flex"
		></Box>
	);
};

export default MapRoot;
